// REDUCER
import * as actionTypes from '../constants/actions';
import { filter } from 'lodash';

const defaultState = {
	cases: [],
	winners: filter(konfig.caseMenu, ['type', 'awards']) || [],
	single: {},
	isFetching: false,
};

function casesReceived(state, payload) {
	//@TODO: set winners for real on it's own
	state = winnersReceived(state, payload);
	state = setBusy(state, false);

	if (payload.hasOwnProperty('cases')) {
		return {...state, cases: payload.cases, next: payload.next, prev: payload.prev};
	}

	return state;
}

function contextualCasesReceived(state, payload) {
	state = setBusy(state, false);

	if (payload.cases && payload.cases.length) {
		return {...state, contCases: payload.cases, next: payload.next, prev: payload.prev, error: null, totalCases: payload.totalCases, total: payload.total};
	}

	if (payload.error) {
		return {...state, error: payload.error, contCases: null};
	}

	return {...state};

}

function winnersReceived(state, payload) {
	if (payload.hasOwnProperty('cases')) {
		return {...state, winners: payload.cases};
	}

	return state;
}

function singleCaseReceived(state, payload) {
	state = setBusy(state, false);
	if (typeof payload === 'object' && payload.hasOwnProperty('id') && payload.hasOwnProperty('typeId')) {
		if (!payload.hasOwnProperty('contents')) {
			payload.contents = [];
		}

		if (!payload.hasOwnProperty('sections')) {
			payload.sections = [];
		}

		return {...state, single: payload};
	}

	return state;
}

function setBusy(state, payload = true) {
	return {...state, isFetching: payload};
}

function reqSingleCase(state, payload = true) {
	state = setBusy(state, true);

	return {...state, single: {}};
}

export default function caseReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.CASES_RECV_DATA:
			return casesReceived(state, action.payload);
			break;
		case actionTypes.CASES_RECV_DATA_CONT:
			return contextualCasesReceived(state, action.payload);
		case actionTypes.CASES_REQ_DATA:
			return setBusy(state, true);
		case actionTypes.CASES_RECV_ERROR:
			return setBusy(state, false);
		case actionTypes.CASES_RECV_SINGLE_DATA:
			return singleCaseReceived(state, action.payload);
		case actionTypes.CASES_REQ_SINGLE_DATA:
			return reqSingleCase(state);
		case actionTypes.CASES_CLEAR_DATA:
			return {...state, single: {}, update: 0};
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/cases.js
 **/